// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"701ab867","227":"bd8b94ca","228":"74dc76a6","416":"af457d6d","514":"668f831b","522":"acecddc4","618":"78c8d14a","693":"3ce49e4f","714":"eab632b6","818":"72256256","824":"4ce2c064","927":"1a9a3662"}[chunkId] + ".chunk.js";
};